import { render, staticRenderFns } from "./DataLabel.vue?vue&type=template&id=527e8676&scoped=true"
import script from "./DataLabel.vue?vue&type=script&lang=ts"
export * from "./DataLabel.vue?vue&type=script&lang=ts"
import style0 from "./DataLabel.vue?vue&type=style&index=0&id=527e8676&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527e8676",
  null
  
)

export default component.exports